function createElement(tag, className, text) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
}

function createQuestion(question) {
  const group = createElement('fieldset', 'form-group kurzbewerbung-custom-question');
  group.dataset.customQuestionGroup = '';
  group.dataset.questionId = question.id;
  group.dataset.questionType = question.type;
  const legend = createElement('legend', 'col-form-label font-weight-bold', question.question);
  legend.id = `kurzbewerbung-question-label-${question.id}`;
  group.append(legend);
  const name = `kurzbewerbung_custom_questions[${question.id}]`;
  const id = `kurzbewerbung-custom-question-${question.id}`;
  if (question.type === 'radio' || question.type === 'checkbox') {
    const options = createElement('div', 'kurzbewerbung-custom-question__options');
    question.options.forEach(option => {
      const label = createElement('label', 'kurzbewerbung-custom-question__option');
      const input = createElement('input');
      input.type = question.type;
      input.id = `${id}-${option.id}`;
      input.name = name + (question.type === 'checkbox' ? '[]' : '');
      input.value = option.id;
      input.disabled = true;
      if (question.type === 'checkbox') input.dataset.requiredCheckbox = '';
      else input.required = true;
      label.htmlFor = input.id;
      label.append(input, createElement('span', '', option.label));
      options.append(label);
    });
    group.append(options);
  } else {
    const tag = question.type === 'textarea' ? 'textarea' : question.type === 'select' ? 'select' : 'input';
    const input = createElement(tag, 'form-control');
    input.id = id;
    input.name = name;
    input.disabled = true;
    input.required = true;
    input.setAttribute('aria-labelledby', legend.id);
    if (tag === 'select') {
      const placeholder = createElement('option', '', 'Bitte auswählen');
      placeholder.value = '';
      input.append(placeholder);
      question.options.forEach(option => {
        const element = createElement('option', '', option.label);
        element.value = option.id;
        input.append(element);
      });
    } else {
      input.placeholder = 'Bitte eingeben';
      if (question.type === 'number') {
        input.type = 'number';
        input.step = 'any';
        input.inputMode = 'decimal';
      } else {
        input.maxLength = tag === 'textarea' ? 5000 : 500;
        if (tag === 'textarea') input.rows = 5;
        else input.type = 'text';
      }
    }
    group.append(input);
  }
  group.append(createElement('div', 'invalid-feedback', 'Bitte beantworte diese Frage.'));
  return group;
}

export function renderCustomQuestions(form) {
  const container = form.querySelector('[data-custom-questions-container]');
  const dataElement = document.getElementById('pme-custom-questions-data');
  if (!container || !dataElement) return;
  const data = JSON.parse(dataElement.textContent);
  const jobId = form.querySelector('#job-position').value;
  const locationId = form.querySelector('#job-location').value;
  const job = data.jobs[jobId];
  const questions = [...data.global, ...(job ? (job.locations[locationId] || job.questions) : [])];
  // Reuse unchanged fields, including values and server validation messages.
  const existing = new Map(Array.from(container.children).map(element => [element.dataset.questionId, element]));
  const fragment = document.createDocumentFragment();
  questions.forEach(question => fragment.append(existing.get(question.id) || createQuestion(question)));
  container.replaceChildren(fragment);
}
